<template>
  <div>
    <v-row>
      <v-col align="left">
        <v-card
          outlined
          class="mx-auto my-12"
          max-width="374"
          color="cardIsland"
        >
          <v-card-title class="text-h6 font-weight-bold"><v-icon style="color:#00FF94">mdi-check-bold</v-icon>&nbsp;{{capitaliseFirstLetter(this.orderType)}} order status:&nbsp;
            <span class="text-uppercase" style="color:#00FF94">{{orderStatus}}</span>
          </v-card-title>
          <v-card-text>
            Your {{orderType}} order status is now "PAID" and a receipt has been sent to your email.
          </v-card-text>
          <v-divider></v-divider>
          <v-card-title class="text-h6 font-weight-bold">Details</v-card-title>
          <OrderDetails :orderType="orderType" :isReceipt="true"/>
          <v-divider></v-divider>
          <v-card-title class="text-h6 font-weight-bold">Thank you</v-card-title>
          <v-card-text>
            Thank you for choosing us. We look forward to doing business with you again soon.
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import OrderDetails from "../OrderDetails.vue" 
import { utilsMixin } from '../../mixins/utilsMixin.js'

export default {
  props: ["orderType", "orderStatus"],
  components: {
    OrderDetails,
  },
  mixins: [utilsMixin],
  data() {
    return {
      isNewAddressSelected: false,
      sellOrderNewAddressType: 'bank',
      saveToAddressBook: true,
      toggle_exclusive: 3,
      paymentMethod: 'address',
    }
  },
  methods: {
  },
  mounted() {
    console.log(this.orderType)
    console.log(typeof this.orderType)
  },
}
</script>
